module.exports = __webpack_public_path__ + "static/media/Galeria_Empresariales_5-1.27de841d.jpg";